/*
 * @Author: JettyHuang
 * @LastEditors: JettyHuang
 * @Description:
 * @Date: 2021-03-03 18:15:48
 * @LastEditTime: 2021-04-16 13:38:07
 * @FilePath: /yft-b2c-web-h5/src/pages/Shop/Product/Qualification/QualificationMod.js
 */
import { observable, action, flow } from 'mobx';
import { get } from 'lodash';
import Serv from './QualificationServ';
import Util from 'utils';
import { initConfig } from 'utils/wxUtils';
import { shareFriend, sharePyq } from 'utils/wxShare';
import Stores from 'config/Stores';
import { cloneDeep } from 'lodash';

const defaultListData = {
  data: null,
  isLoading: false,
  hasPullToRefresh: true,
  pageNum: 1,
  pages: 1
};

class QualificationMod {
  // 分页数量
  @observable pageSize = 10;
  // 分页页数
  @observable pageNum = 0;
  // 最大分页数量
  @observable maxPageNum = 1;
  // 下载app
  @observable appDownloadGuide = 0;
  // 资格购活动id
  @observable id = '';

  @observable hasRequest = false; // 是否已请求

  @observable scrollTop = 0; // 滚动高度

  @observable productList = [];
  // 店长 1:3 不允许加入购物车
  @observable allowDistributionRatio = false;

  // 产品列表数据
  @observable listData = defaultListData;

  // 活动基本信息
  @observable activityBaseInfo = {};

  // 活动截止时间
  @observable lastTime = '';

  shareCardCode = '';

  @observable flag = 1;

  @observable activity = 1;
  // 资格购前端隐藏，可以通过跳转链接参与活动
  @observable showFlag = false;

  // 代客信息
  dgInfo = {};

  @action
  changeModState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  shareActivity = () => {
    const isWeChat = Util.isWeiXin();

    if (!this.id || !isWeChat) return;

    initConfig(true); // 初始化微信配置

    const { activityName, banner } = this.activityBaseInfo;

    const { cardCode } = Stores.AppMod.userInfo || {};

    const shareCardCode = this.shareCardCode || cardCode;

    const title = `${activityName || ''}`;
    const desc = `我在有享云商发现一个不错的活动，赶快来看看吧`;
    const link = `${window.location.origin}${window.location.pathname}#/shop/qualification?id=${this.id}&showFlag=${this.showFlag}&cardCode=${shareCardCode}&subActivityId=${sessionStorage.getItem('subActivityId')}&subActivityChannel=${sessionStorage.getItem('subActivityChannel')}`;

    // 分享给朋友
    shareFriend({
      title,
      desc,
      link,
      imgUrl: banner,
      suc: () => {}
    });

    // 分享到朋友圈
    sharePyq({
      title,
      link,
      imgUrl: banner,
      suc: () => {}
    });
  };

  /**
   * 获取产品列表
   */
  getQualification = flow(function* (pageNum = 1) {
    let { listData } = this;

    this.listData.isLoading = true;
    if (pageNum === 1) {
      this.listData.data = [];
    }

    try {
      const { data = {} } = yield Serv.getQualification({ pageSize: 10, pageNum }, {});

      this.listData.isLoading = false;
      if (pageNum !== 1) {
        const arr = listData.data || [];
        this.listData.data = arr.concat(data.list || []);
      } else {
        this.listData.data = data.list || [];
      }
      // 重置页数等信息
      this.listData.pageNum = data.pageNum;
      this.listData.pages = data.pages;
    } catch (error) {}

    this.hasRequest = true;
  });

  // 如果是分享进来的 就调用分页接口
  @action
  getSharePage = flow(function* (cardCode) {
    if (this.pageNum + 1 <= this.maxPageNum && cardCode) {
      let options = {
        url: `promotion/activity/item/page`,
        data: {
          id: this.id,
          memberCard: cardCode,
          saleMode: this.activityBaseInfo.saleMode,
          pageNum: this.pageNum + 1,
          pageSize: this.pageSize
        }
      };
      const { data } = yield Serv.getPage(options);
      this.pageNum += 1;
      this.maxPageNum = data.pages;
      this.productList = [
        ...this.productList,
        ...data.list.map((item) => ({
          ...item,
          id: item.itemId,
          name: item.itemName,
          code: item.itemCode,
          price: item.discountSalePrice,
          originPrice: item.salePrice,
          picturePath: get(item, 'mediaRespDtoList[0].path1'),
          imgUrl: get(item, 'mediaRespDtoList[0].path1')
        }))
      ];
    }
  });

  /**
   * 获取产品列表
   */
  getProductList = flow(function* (cardCode) {
    let params = '';
    if (cardCode) {
      params = '?isContainsItem=0';
    }
    let { data } = yield Serv.getProductList(this.id, params);
    // 当前登录人是周老师的时候，特殊资格购活动specialQualificationTag是1
    // 当前登录人是其他的时候，特殊资格购活动specialQualificationTag是null
    // 非特殊资格购活动specialQualificationTag是0
    const specialQualificationTag = data.specialQualificationTag;
    const baseReqDto = cloneDeep(data.baseReqDto);
    if (data.baseReqDto) {
      const { flag } = data.baseReqDto || {};
      this.flag = flag;
      this.allowDistributionRatio = !!data.baseReqDto.allowDistributionRatio;
    }
    if (!cardCode) {
      data = data.itemReqDto.itemReqDtos.map((item) => ({
        ...item,
        id: item.itemId,
        name: item.itemName,
        code: item.itemCode,
        price: item.discountSalePrice,
        originPrice: item.salePrice,
        picturePath: get(item, 'mediaRespDtoList[0].path1'),
        imgUrl: get(item, 'mediaRespDtoList[0].path1')
      }));
      if (specialQualificationTag === null) {
        // 周老师特殊的资格购活动，只有周老师登录的时候才显示，其他用户不显示，此除特殊处理直接分享周老师资格购的场景(普通的资格购改字段不返回)
        data = [];
      }
      this.productList = data;
    }

    this.activityBaseInfo = baseReqDto || {};
    if (baseReqDto.appDownloadGuide != undefined) {
      this.appDownloadGuide = baseReqDto.appDownloadGuide;
    }
    this.shareActivity();
    let invalidTime = baseReqDto.invalidTime || '';
    let lastTime = new Date(invalidTime).getTime();
    this.lastTime = lastTime;
  });

  /**
   * 促销活动状态
   */
  getActivity = flow(function* (pageNum = 1) {
    let { data } = yield Serv.getActivity(this.id);
    return data;
  });

  @action
  resetData() {
    this.listData = defaultListData;
    this.hasRequest = false;
    this.scrollTop = 0;
  }
}

const qualificationMod = new QualificationMod();
export default qualificationMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Product/Qualification/QualificationMod.js